import { Star } from "lucide-react";

export const StarRating = ({ rating = 0, onRate, size = "md", readOnly = false }) => {
  const sizes = { sm: "w-3.5 h-3.5", md: "w-5 h-5", lg: "w-6 h-6" };
  const s = sizes[size] || sizes.md;

  return (
    <div className="flex gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => !readOnly && onRate?.(star)}
          disabled={readOnly}
          className={`${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"} transition-transform duration-150`}
          data-testid={`star-${star}`}
        >
          <Star
            className={`${s} transition-colors duration-150 ${
              star <= rating
                ? "fill-sandy text-sandy"
                : "text-midnight/15 fill-transparent"
            }`}
          />
        </button>
      ))}
    </div>
  );
};
